import { render, staticRenderFns } from "./action-button.vue?vue&type=template&id=5b7cd0b0&scoped=true"
import script from "./action-button.vue?vue&type=script&lang=js"
export * from "./action-button.vue?vue&type=script&lang=js"
import style0 from "./action-button.vue?vue&type=style&index=0&id=5b7cd0b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7cd0b0",
  null
  
)

export default component.exports